var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.587185 15.9167L0.576343 15.7422C0.576352 15.0328 1.10716 14.4475 1.79323 14.3616L1.96778 14.3508L14.35 14.35L14.3508 1.96776C14.3508 1.19932 14.9737 0.576327 15.7422 0.576346C16.5106 0.576376 17.1336 1.19933 17.1336 1.96778L17.1344 14.35L29.5166 14.3508C30.226 14.3508 30.8113 14.8816 30.8972 15.5676L30.908 15.7422C30.908 16.4516 30.3772 17.0369 29.6912 17.1228L29.5166 17.1336L17.1344 17.1344L17.1336 29.5166C17.1336 30.285 16.5106 30.908 15.7422 30.908C14.9737 30.908 14.3508 30.2851 14.3508 29.5166L14.35 17.1344L1.96778 17.1336C1.25842 17.1336 0.673049 16.6028 0.587185 15.9167L0.576343 15.7422L0.587185 15.9167Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGray);
export default __webpack_public_path__ + "static/media/plus_gray.809c69cf810fb32431687752f6259e14.svg";
export { ForwardRef as ReactComponent };